import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Menu, { SubMenu, MenuItem } from 'rc-menu';
import $ from 'jquery/dist/jquery';
import _ from 'underscore';

import { webApiConfig } from 'src/config';

const path = {
  1: '/service/top',
  '2-1': '/service/bbt_racks',
  '2-2-1-1-1': '/service/dc_assists/auth_groups',
  '2-2-1-2-1': '/service/dc_assists/admission_persons',
  '2-2-1-2-2': '/service/dc_assists/admission_persons/new',
  '2-2-1-2-3': '/service/dc_assists/admission_persons/bulk_new',
  '2-2-1-3-1': '/service/dc_assists/admission_histories',
  '2-2-1-3-2': '/service/dc_assists/room_access_histories',
  '2-2-1-4-1': '/service/dc_assists/carry_requests',
  '2-2-1-4-2': '/service/dc_assists/carry_requests/new_in_01',
  '2-2-1-4-2': '/service/dc_assists/carry_requests/new_in_02',
  '2-2-1-4-2': '/service/dc_assists/carry_requests/new_out_01',
  '2-2-1-4-2': '/service/dc_assists/carry_requests/new_out_02',
  '2-2-1-4-2': '/service/dc_assists/carry_requests/new_delivery',
  '2-2-1-4-2': '/service/dc_assists/carry_requests/new',
  '2-2-1-5-1': '/service/dc_assists/mdf_requests',
  '2-2-1-5-2': '/service/dc_assists/mdf_requests/new',
  '3-1-1': '/service/system_monitoring_messages'
};

const currentPathKey = (location) => {
  const result = Object.keys(path).filter((k) => {
    return path[k] == location;
  })[0];
  if (result) {
    return result;
  } else {
    const paths = location.split('/');
    if (paths.length == 5) {
      switch (paths[3]) {
        case 'auth_groups':
          return '2-2-1-1-1';
          break;
        case 'admission_persons':
          return '2-2-1-2-1';
          break;
        case 'carry_requests':
          return '2-2-1-4-2';
          break;
        case 'mdf_requests':
          return '2-2-1-5-1';
          break;
        default:
          return '1';
          break;
      }
    } else if (paths.length == 4) {
      switch (location.split('/')[2]) {
        default:
          return '1';
          break;
      }
    }
  }
};

const genDefaultOpenKeys = (key) => {
  const defaultOpenKeys = [];
  const array = key.split('-');
  for (let i = array.length; i > 0; i -= 1) {
    defaultOpenKeys.push(array.join('-'));
    array.pop();
  }
  return defaultOpenKeys;
};

const NavBar = () => {
  const location = useLocation();
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();

  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([
    currentPathKey(location.pathname)
  ]);
  const [defaultOpenKeys, setDefaultOpenKeys] = useState(
    genDefaultOpenKeys(currentPathKey(location.pathname))
  );
  const [disabledMenus, setDisabledMenus] = useState({
    bbt_rack: {
      index: true
    },
    system_monitoring_message: {
      index: true
    },
    dc_assist_auth_group: {
      index: true
    },
    dc_assist_admission_person: {
      index: true,
      create: true
    },
    dc_assist_admission_history: {
      index: true
    },
    dc_assist_room_access_history: {
      index: true
    },
    dc_assist_carry_request: {
      index: true,
      create: true
    }
  });

  useEffect(() => {
    let isMounted = true;

    const _setDisabledMenus = async () => {
      const accessToken = await getAccessTokenSilently();
      let results = await $.ajax({
        url: `${webApiConfig.baseUri.bff}/common/accounts/abilities`,
        type: 'GET',
        async: false,
        dataType: 'json',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
        }
      }).responseText;
      results = results ? JSON.parse(results) : [];
      const newDisabledMenus = disabledMenus;
      _.keys(results).forEach((domain) => {
        results[domain].forEach((ability) => {
          const domain_name = domain.replace(/\//g, '_');
          if (disabledMenus[domain_name]) {
            newDisabledMenus[domain_name][ability] = false;
          }
        });
      });
      if (isMounted) {
        setDisabledMenus({ ...disabledMenus, ...newDisabledMenus });
      }
    };

    _setDisabledMenus();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setDefaultSelectedKeys([currentPathKey(location.pathname)]);
      setDefaultOpenKeys(genDefaultOpenKeys(currentPathKey(location.pathname)));
    }

    return () => {
      isMounted = false;
    };
  }, [location.pathname]);

  const onClick = (info) => {
    history.push(path[info.key]);
  };

  const onTitleClick = (info) => {
    if (defaultOpenKeys.find((key) => key === info.key)) {
      const newKeys = defaultOpenKeys.filter((key) => key !== info.key);
      setDefaultOpenKeys(newKeys);
    } else {
      setDefaultOpenKeys([...defaultOpenKeys, info.key]);
    }
  };

  return (
    <div>
      <div>
        <Menu
          onClick={onClick}
          mode="inline"
          selectedKeys={defaultSelectedKeys}
          openKeys={defaultOpenKeys}
        >
          <MenuItem key="1">ホーム</MenuItem>
          <SubMenu key="2" title="データセンター" onTitleClick={onTitleClick}>
            <MenuItem key="2-1" disabled={disabledMenus.bbt_rack.index}>
              ラック電流値管理
            </MenuItem>
            <SubMenu
              className="rc-menu-nest-submenu"
              key="2-2"
              title="入退館管理"
              onTitleClick={onTitleClick}
            >
              <SubMenu
                className="rc-menu-nest-submenu"
                key="2-2-1"
                title="新大手町"
                onTitleClick={onTitleClick}
              >
                <SubMenu
                  className="rc-menu-nest-submenu"
                  key="2-2-1-1"
                  title="権限グループ管理"
                  onTitleClick={onTitleClick}
                >
                  <MenuItem
                    key="2-2-1-1-1"
                    disabled={disabledMenus.dc_assist_auth_group.index}
                  >
                    一覧
                  </MenuItem>
                </SubMenu>
                <SubMenu
                  className="rc-menu-nest-submenu"
                  key="2-2-1-2"
                  title="入館者管理"
                  onTitleClick={onTitleClick}
                >
                  <MenuItem
                    key="2-2-1-2-1"
                    disabled={disabledMenus.dc_assist_admission_person.index}
                  >
                    一覧
                  </MenuItem>
                  <MenuItem
                    key="2-2-1-2-2"
                    disabled={disabledMenus.dc_assist_admission_person.create}
                  >
                    登録
                  </MenuItem>
                  <MenuItem
                    key="2-2-1-2-3"
                    disabled={disabledMenus.dc_assist_admission_person.create}
                  >
                    一括登録
                  </MenuItem>
                </SubMenu>
                <SubMenu
                  className="rc-menu-nest-submenu"
                  key="2-2-1-5"
                  title="MDF入室管理"
                  onTitleClick={onTitleClick}
                >
                  <MenuItem
                    key="2-2-1-5-1"
                    disabled={disabledMenus.dc_assist_admission_person.index}
                  >
                    一覧
                  </MenuItem>
                  <MenuItem
                    key="2-2-1-5-2"
                    disabled={disabledMenus.dc_assist_admission_person.create}
                  >
                    申請
                  </MenuItem>
                </SubMenu>
                <SubMenu
                  className="rc-menu-nest-submenu"
                  key="2-2-1-3"
                  title="履歴管理"
                  onTitleClick={onTitleClick}
                >
                  <MenuItem
                    key="2-2-1-3-1"
                    disabled={disabledMenus.dc_assist_admission_history.index}
                  >
                    入館受付履歴
                  </MenuItem>
                  <MenuItem
                    key="2-2-1-3-2"
                    disabled={disabledMenus.dc_assist_room_access_history.index}
                  >
                    入室履歴
                  </MenuItem>
                </SubMenu>
                <SubMenu
                  className="rc-menu-nest-submenu"
                  key="2-2-1-4"
                  title="搬入出管理"
                  onTitleClick={onTitleClick}
                >
                  <MenuItem
                    key="2-2-1-4-1"
                    disabled={disabledMenus.dc_assist_carry_request.index}
                  >
                    一覧
                  </MenuItem>
                  <MenuItem
                    key="2-2-1-4-2"
                    disabled={disabledMenus.dc_assist_carry_request.create}
                  >
                    申請
                  </MenuItem>
                </SubMenu>
              </SubMenu>
            </SubMenu>
          </SubMenu>
          <SubMenu key="3" title="MSP" onTitleClick={onTitleClick}>
            <SubMenu
              className="rc-menu-nest-submenu"
              key="3-1"
              title="監視"
              onTitleClick={onTitleClick}
            >
              <MenuItem
                key="3-1-1"
                disabled={disabledMenus.system_monitoring_message.index}
              >
                自動電話通知ログ
              </MenuItem>
            </SubMenu>
          </SubMenu>
        </Menu>
      </div>
    </div>
  );
};

export default NavBar;
